import script from "./ticket-support.vue?vue&type=script&setup=true&lang=js"
export * from "./ticket-support.vue?vue&type=script&setup=true&lang=js"

import "./ticket-support.vue?vue&type=style&index=0&id=43d08e23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d08e23"]])

export default __exports__